import { Spacing } from "../../../foundations/spacing.es.js";
import { styled } from "@mui/material";
import { Typography } from "../../typography/typography.es.js";
import { FontWeight } from "../../../foundations/typography.es.js";
const LETTER_SPACING_0_1 = "0.1px";
const TooltipTitleTypographyContainer = styled(Typography)({
  lineHeight: "157%",
  fontSize: Spacing["875"],
  letterSpacing: LETTER_SPACING_0_1,
  fontWeight: FontWeight.bold
});
export {
  TooltipTitleTypographyContainer
};
//# sourceMappingURL=title-typography-container.es.js.map
